mutation ProvisionZoomAsync {
    provisionZoomAsync {
        meetingId
        meetingUuid
        meetingUrl
        serviceType
    }
}
